<div class="modal-body wrapper-modal">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <!-- Title -->
    <p class="title">
        ¡Políticas sin aceptar!
    </p>

    <!-- Description HTML -->
    <p id="descriptionHTML">
        El usuario <b>{{data.name}} ({{data.document}})</b> no tiene vigente una o varias de las siguientes políticas:
    </p>

    <ol>
        <li *ngFor="let legalDocument of legalDocumentsInvalid">
            {{legalDocument}}
        </li>
    </ol>
    <ol *ngIf="!legalDocumentsInvalid.length">
        <li>Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales Teclogi Cargo</li>
        <li *ngIf="isTeclogiUser">Contrato de vinculación Teclogi Cargo</li>
        <li *ngIf="isTeclogiUser">Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales Teclogi Logistics</li>
        <li *ngIf="isTeclogiUser">Contrato de vinculación Teclogi Logistics</li>
        <li>Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales LoggiApp</li>
        <li>Términos y condiciones LoggiApp</li>
        <li *ngIf="isTeclogiUser">Contrato de Fáctoring comercial</li>
    </ol>

    <p>
        ¿Desea enviarle la solicitud al número
        <b>{{data.phone}}</b>
        <i permission-display [module]="permission.administration.module"
            [functionality]="permission.administration.modifyBasicFieldsUser" (click)="changePhone()"
            class="fas fa-pencil-alt color-primary cursor-pointer" matTooltip="Modificar número"
            matTooltipPosition="above"></i>
        ?
    </p>
    <p class="my-2 text-bold">
        Seleccione el canal por el cual desea enviar la solicitud:
    </p>
    <div class="d-flex flex-wrap justify-content-around">
        <div class="button-terms-and-conditions" (click)="copyDriverRegistration()"
            matTooltip="Permite copiar la dirección del enlace al portapapeles para compartirlo fácilmente al conductor"
            matTooltipClass="tooltip__alert">
            <i class="far fa-copy fa-lg"></i>
            <p class="d-none d-sm-block">Copiar enlace</p>
        </div>
        <div class="button-terms-and-conditions" (click)="submit()"
            matTooltip="Permite enviar un mensaje de texto al número del conductor para la aceptación"
            matTooltipClass="tooltip__alert">
            <i class="fas fa-sms fa-lg"></i>
            <p class="d-none d-sm-block">Mensaje de texto</p>
        </div>
        <div class="button-terms-and-conditions" (click)="sendMessageToWhatsapp()"
            matTooltip="Permite enviar un mensaje directo al whatsapp del conductor con el enlace para la aceptación"
            matTooltipClass="tooltip__alert">
            <i class="fab fa-whatsapp fa-lg"></i>
            <p class="d-none d-sm-block">WhatsApp</p>
        </div>
    </div>
</div>